export const notifySuccess = (message) => {
  window.alert(message);
};

export const notifyError = (message) => {
  window.alert(message);
};

export const notifyInfo = (message) => {
  window.alert(message);
};
